import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=2353a29b&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2353a29b')) {
      api.createRecord('2353a29b', component.options)
    } else {
      api.reload('2353a29b', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=2353a29b&", function () {
      api.rerender('2353a29b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JPWUkWqt7wOt/JS/childrenage.vue"
export default component.exports